import type { IconSize } from "@circleco/compass/components/Icon";
import { IconButton } from "@circleco/compass/components/IconButton";
import { Tooltip } from "@circleco/compass/components/Tooltip";

import { t } from "@/i18n-js/instance";
import { useToast } from "@/react/components/SettingsApp/CompassCompat/Toast";

import { NOTIFICATION_ACTION_MAPPER } from "../List/Item/constants";
import { useNotificationContext } from "../NotificationContext";
import { useNotificationsActions } from "../useHeaderNotificationsApi";

export const MarkAsReadButton = ({
  iconSize = "md",
}: {
  iconSize?: IconSize;
}) => {
  const toast = useToast();
  const { setLastMarkedAsRead } = useNotificationContext();

  const onSuccess = (data: any) => {
    toast.success(t("header_v3.notifications_marked_as_read"));
    if (data.success) {
      const lastMarkedAsReadTime = new Date(data?.read_at_time).getTime();
      setLastMarkedAsRead(lastMarkedAsReadTime);
    }
  };

  const {
    mutate: performNotificationAction,
    isLoading: areNotificationsBeingMarkedAsRead,
  } = useNotificationsActions(onSuccess);

  return (
    <Tooltip content={t("header_v3.mark_all_as_read")}>
      <IconButton
        icon="checkmark-double"
        size={iconSize}
        variant="ghost"
        onClick={() =>
          performNotificationAction({
            action: NOTIFICATION_ACTION_MAPPER.markAllAsRead,
          })
        }
        loading={areNotificationsBeingMarkedAsRead}
        aria-label={t("header_v3.mark_all_as_read")}
      />
    </Tooltip>
  );
};
